import { motion } from "framer-motion";
import { Users, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { resolveMediaUrl } from "@/lib/api";

export const Rooms = ({ rooms = [], onEnquire }) => (
  <section id="rooms" className="bg-[#0A192F] py-20 md:py-28 relative overflow-hidden" data-testid="rooms-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
        <SectionHeading eyebrow="Stay With Us" title="Rooms & Suites" dark testId="rooms" />
        <Reveal delay={0.15}>
          <p className="text-[#F8F6F0]/60 text-sm max-w-xs">Every rate is best-guaranteed when you call us direct. No fees, ever.</p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {rooms.map((room, i) => (
          <Reveal key={room.id || room.name} delay={i * 0.08}>
            <motion.div
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="group bg-[#0D1B2A] border border-[#C5A059]/15 rounded-2xl overflow-hidden hover:border-[#C5A059]/50 transition-colors duration-500"
              data-testid={`room-card-${room.id || i}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={resolveMediaUrl(room.image)}
                  alt={room.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3 bg-[#0A192F]/85 backdrop-blur px-3 py-1.5 rounded-full text-[#C5A059] text-sm font-semibold" data-testid={`room-rate-${room.id || i}`}>
                  ${room.rate}<span className="text-[#F8F6F0]/60 text-xs font-normal">/night</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-serif-display text-xl font-semibold text-[#F8F6F0]">{room.name}</h3>
                <p className="text-[#F8F6F0]/55 text-xs mt-1 flex items-center gap-1.5"><Users size={12} /> {room.capacity}</p>
                <p className="text-[#F8F6F0]/70 text-sm mt-3 leading-relaxed">{room.description}</p>
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {(room.amenities || []).map((a) => (
                    <span key={a} className="text-[10px] uppercase tracking-wider text-[#C5A059] border border-[#C5A059]/30 rounded-full px-2.5 py-1">{a}</span>
                  ))}
                </div>
                <button
                  onClick={() => onEnquire(room.name)}
                  className="mt-5 w-full text-sm font-medium text-[#F8F6F0] border border-[#F8F6F0]/20 hover:bg-[#C5A059] hover:text-[#0A192F] hover:border-[#C5A059] rounded-full py-2.5 transition-all duration-300 flex items-center justify-center gap-2"
                  data-testid={`room-enquire-button-${room.id || i}`}
                >
                  Enquire <ArrowUpRight size={14} />
                </button>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
